import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import getConfig, { OMFE2ConfigModel, CustomContentAreaPosition, BannerMatrixConfig } from '@om-fe/core/utils/config';
import { sidebarBem } from '@om-fe/core/components/constants';
import CustomContentArea from '@om-fe/core/components/custom-content/custom-content-area';
import { compose } from 'redux';
import withTranslation from '@om-fe/core/core/i18n/with-translation';
import { I18nContextInterface } from '@om-fe/core/core/i18n/utils';
import { EMRoutingContextInterface, RouteModel, RouteNames } from '@om-fe/core/core/routing/utils';
import withRouting from '@om-fe/core/core/routing/with-routing';
import { createBem, OddsFormat } from '@om-fe/utils';
import { BetslipWrapperDesktop } from './betslip-wrapper/betslip-wrapper-desktop';
import MatchDetailsSidebarBetradar from '../components/match-details/match-details-sidebar-betradar';
import { DisciplineLiveStatus } from '@om-fe/models';
import { BrowserOnly } from '@om-fe/widgets/dist/components/ssr/browser-only';
import BannermatrixBanner from '@om-fe/core/components/external-widgets/bannermatrix-banner';
import { StreamModalLoadLazy } from '@om-fe/core/core/widgets/omfe-widgets';
import { PanicButton } from '@om-fe/core/components/panic-button/panic-button';
import JackpotBanner from '@om-fe/core/components/jackpot/jackpot-banner';

type RightSideBarWrapperPublicProps = {}
type RightSideBarWrapperStoreProps = {
    isAuthenticated: boolean,
    oddsFormat: OddsFormat,
}

type RightSideBarWrapperProps = RightSideBarWrapperPublicProps
    & RouteComponentProps<{ readonly id: string; readonly disciplineId: string; }>
    & EMRoutingContextInterface
    & I18nContextInterface
    & RightSideBarWrapperStoreProps;


const rightSideBarTab = createBem('RightSideBarTab');
const panicButtonEnabled: boolean = !!getConfig().panicButton?.enabled;
const jackpotEnabled: boolean = !!getConfig().jackpot?.enabled;

class RightSideBarComponent extends React.PureComponent<RightSideBarWrapperProps> {
    parentContainerRef: React.RefObject<HTMLDivElement> = React.createRef();

    state = {
        isResized: false,
    }

    handleIsResized = () => {
        const { isResized } = this.state;

        this.setState({
            isResized: !isResized,
        })
    }

    render() {
        const {
            match: { params: { id, disciplineId }, url },
            getRouteByUrl,
            language,
        } = this.props;
        const routeModel: RouteModel | undefined = getRouteByUrl(url);
        const routeName: RouteNames | undefined = routeModel && routeModel.name;
        const { isResized } = this.state;
        const config: OMFE2ConfigModel = getConfig();
        const bannerMatrixConfig: BannerMatrixConfig | undefined = config.bannerMatrix;
        const enableMatchHeaderDefaultAndHighlighted: boolean | undefined = config.enableMatchHeaderDefaultAndHighlighted;
        const showMatchDetailsSidebarBetradar: boolean =
            (enableMatchHeaderDefaultAndHighlighted && routeName === RouteNames.event)
            || (!enableMatchHeaderDefaultAndHighlighted && (routeName === RouteNames.liveEvent || routeName === RouteNames.event))
        ;

        return (
            <aside className={sidebarBem({
                modifiers: {
                    Right: true,
                    isResized: !!isResized,
                },
            })}
            >
                <BrowserOnly>
                    <>
                        {jackpotEnabled && (
                            <JackpotBanner />
                        )}
                        <div className={sidebarBem('Wrapper')} ref={this.parentContainerRef}>
                            <BetslipWrapperDesktop className={rightSideBarTab()} />
                            {panicButtonEnabled && ( <PanicButton /> )}
                        </div>
                        {(routeName === RouteNames.nextRaceEvent) && (
                            <StreamModalLoadLazy hasOverlay={true} parent={true} />
                        )}
                        {showMatchDetailsSidebarBetradar &&    
                            <MatchDetailsSidebarBetradar
                                disciplineId={disciplineId}
                                matchId={id}
                                lang={language}
                                liveStatus={(routeName === RouteNames.liveEvent) ? DisciplineLiveStatus.LIVE : DisciplineLiveStatus.NOT_LIVE}
                            />
                        }
                        {bannerMatrixConfig && (
                            <>
                                <BannermatrixBanner
                                    className="BannerWidgetRightUnderBetslip BannerWidgetColorPack"
                                    positionTag="right-under-betslip"
                                />
                                {bannerMatrixConfig?.showOnBetslip && (
                                    <BannermatrixBanner
                                        className="BannerWidgetRightUnderBetslip2 BannerWidgetColorPack"
                                        positionTag="right-under-betslip-2"
                                    />
                                )}
                                {bannerMatrixConfig?.showOnBetslipThird && (
                                    <BannermatrixBanner
                                        className="BannerWidgetRightUnderBetslip3 BannerWidgetColorPack"
                                        positionTag="right-under-betslip-3"
                                    />
                                )}
                            </>
                        )}
                        <CustomContentArea contentRef={CustomContentAreaPosition.BOTTOM_RIGHT_1} />
                        <CustomContentArea contentRef={CustomContentAreaPosition.BOTTOM_RIGHT_2} />
                    </>
                </BrowserOnly>
            </aside>
        );
    }
}

const RightSideBar: React.ComponentType<RightSideBarWrapperPublicProps> = compose<React.ComponentType<RightSideBarWrapperPublicProps>>(
    withTranslation<RightSideBarWrapperPublicProps>(),
    withRouting(),
)(RightSideBarComponent);
export default RightSideBar;
